import { useEffect, useState } from 'react'
import { auth } from '../../firebase'
import { Layout, Space, Image, Button, Modal, Tabs, Form, Input, message } from 'antd'
import btm_logo from '../../assets/btm_logo.png'

const { Content } = Layout

const layoutStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh'
}

const contentStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
}

const spaceStyle = {
  width: '100%'
}

const signInBtnStyle = {
  marginTop: '2em'
}

const AuthForm = props => {

  const { 
    type,
    signInEmail,
    setSignInEmail,
    signInPassword,
    setSignInPassword,
    signInDisabled,
    registerEmail,
    setRegisterEmail,
    registerPassword,
    setRegisterPassword,
    registerAccessCode,
    setRegisterAccessCode,
    registerDisabled,
    handleAuth,
    loading
  } = props

  return (
    <Form 
      name='basic' 
      labelCol={{span: 6}} 
      wrapperCol={{span: 16}} 
      style={{maxWidth: 600}}
      initialValues={{remember: true}}
      onFinish={() => handleAuth(type)}
      autoComplete='off'
    >
      <Form.Item
        label='Email'
        name='email'
        rules={[
          {
            required: true,
            message: 'Please input your email!',
          },
        ]}
      >
        <Input 
          value={type === 'signIn' ? signInEmail : registerEmail} 
          onChange={(e) => type === 'signIn' ? setSignInEmail(e.target.value) : setRegisterEmail(e.target.value)}
        />
      </Form.Item>

      <Form.Item
        label='Password'
        name='password'
        rules={[
          {
            required: true,
            message: 'Please input your password!',
          },
        ]}
      >
        <Input.Password 
          value={type === 'signIn' ? signInPassword : registerPassword}
          onChange={(e) => type === 'signIn' ? setSignInPassword(e.target.value) : setRegisterPassword(e.target.value)}
        />
      </Form.Item>

      {type === 'register' &&
        <Form.Item
          label='Access Code'
          name='accessCode'
          rules={[
            {
              required: true,
              message: 'Please input your access code!',
            },
          ]}
        >
          <Input 
            value={registerAccessCode} 
            onChange={(e) => setRegisterAccessCode(e.target.value)}
          />
        </Form.Item>
      }

      <Form.Item wrapperCol={{offset: 10, span: 16 }}>
        <Button type='primary' htmlType='submit' loading={loading} disabled={type === 'signIn' ? signInDisabled : registerDisabled}>
          {type === 'signIn' ? 'Sign In' : 'Register'}
        </Button>
      </Form.Item>
    </Form>
  )
}

const Splash = () => {

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [signInEmail, setSignInEmail] = useState(null)
  const [signInPassword, setSignInPassword] = useState(null)
  const [signInDisabled, setSignInDisabled] = useState(true)
  const [registerEmail, setRegisterEmail] = useState(null)
  const [registerPassword, setRegisterPassword] = useState(null)
  const [registerAccessCode, setRegisterAccessCode] = useState(null)
  const [registerDisabled, setRegisterDisabled] = useState(true)
  const [loading, setLoading] = useState(false)

  const [messageApi, contextHolder] = message.useMessage()

  useEffect(() => {

    // lowercase emails
    const signInEmailLower = signInEmail ? signInEmail.toLowerCase() : null
    const registerEmailLower = registerEmail ? registerEmail.toLowerCase() : null

    // approved domains
    const validExt = ['behindthemarkets.com', 'behindthemarkets.info', 'titanunlimited.com']

    // validate sign in
    const localDomainSignIn = signInEmailLower?.split('@')[1]
    const isSignInValid = !!((validExt.some(ext => localDomainSignIn?.includes(ext)) || signInEmailLower === 'desmat@gmail.com') && signInPassword?.length > 0)
    setSignInDisabled(!isSignInValid)

    // vaidate register
    const localDomainRegister = registerEmailLower?.split('@')[1]
    const isRegisterValid = !!((validExt.some(ext => localDomainRegister?.includes(ext)) || registerEmailLower === 'desmat@gmail.com') && registerPassword?.length > 0 && registerAccessCode === 'btm!')

    setRegisterDisabled(!isRegisterValid)

  }, [signInEmail, signInPassword, registerEmail, registerPassword, registerAccessCode])

  const showModal = () => setIsModalOpen(true)

  const hideModal = () => setIsModalOpen(false)

  const clearForm = () => {
    setSignInEmail(null)
    setSignInPassword(null)
    setSignInDisabled(true)
    setRegisterEmail(null)
    setRegisterPassword(null)
    setRegisterAccessCode(null)
    setRegisterDisabled(true)
    hideModal()
  }

  const handleSignIn = async () => {
    
    // show loading
    setLoading(true)

    try {

      await auth.signInWithEmailAndPassword(signInEmail, signInPassword)

      clearForm()

    } catch (err) {

      messageApi.open({
        type: 'error',
        content: 'Sign in failed.',
      })

    } finally {

      // remove loading
      setLoading(false)
    }
  }

  const handleRegister = async () => {

    // showing loading
    setLoading(true)

    try {

      // Register and send email verification
      await auth.createUserWithEmailAndPassword(registerEmail, registerPassword)
      await auth.currentUser.sendEmailVerification()

      clearForm()

      messageApi.open({
        type: 'success',
        content: 'Registration success, check inbox to confirm email then refresh this page or sign in.',
        duration: 20
      })

    } catch (err) {

      messageApi.open({
        type: 'error',
        content: 'Unable to register.',
      })

    } finally {

      // remove loading
      setLoading(false)
    }
  }

  const handleAuth = type => type === 'signIn' ? handleSignIn() : handleRegister()

  const items = [
    {
      key: '1',
      label: 'Sign In',
      children: <AuthForm 
        type='signIn' 
        signInEmail={signInEmail}
        setSignInEmail={setSignInEmail}
        signInPassword={signInPassword}
        setSignInPassword={setSignInPassword}
        signInDisabled={signInDisabled}
        handleAuth={handleAuth}
        loading={loading}
      />
    },
    {
      key: '2',
      label: 'Register',
      children: <AuthForm 
        type='register'
        registerEmail={registerEmail}
        setRegisterEmail={setRegisterEmail}
        registerPassword={registerPassword}
        setRegisterPassword={setRegisterPassword}
        registerAccessCode={registerAccessCode}
        setRegisterAccessCode={setRegisterAccessCode}
        registerDisabled={registerDisabled}
        handleAuth={handleAuth}
        loading={loading}
      />
    },
  ]

  return (
    <>
      {contextHolder}
      <Space direction='vertical' style={spaceStyle} size={[0, 48]}>
        <Layout style={layoutStyle}>
          <Content style={contentStyle}>

            <Image width={400} src={btm_logo} />

            <Button type='primary' ghost onClick={showModal} style={signInBtnStyle}>
              Sign In
            </Button>

            <Modal open={isModalOpen} footer={null} onCancel={hideModal}>
              <Tabs defaultActiveKey='1' items={items} />
            </Modal>

          </Content>
        </Layout>
      </Space>
    </>
  )
}

export default Splash